export default __webpack_public_path__ + "static/media/KS.b54b6bba.svg";